/* ملف الترجمة: المفتاح هو النص العربي نفسه، والقيمة ترجمته الإنجليزية.
   نبقي الاتجاه RTL ثابتاً؛ نغيّر النص فقط. */

export const translations = {
  "حجز داخلي": "Internal booking",
  "إضافة الترجمة الصوتية للاسم تلقائياً بالحجز الداخلي": "Auto-add phonetic name translation on internal booking",
  "لو الموظف كتب اسم الزبون بالإنجليزي فقط، يضيف النظام تلقائياً \"- الاسم بالعربي\" جنبه، والعكس صحيح لو كتبه بالعربي فقط. تعطيلها يوقف الميزة فوراً حتى بالفعاليات المفتوحة حالياً، ولا يغيّر أي اسم محفوظ سابقاً.": "If staff types the customer's name in English only, the system automatically adds \"- Arabic name\" next to it, and the reverse if typed in Arabic only. Turning it off stops the feature immediately, even for currently open events, and never changes any previously saved name.",
  "إضافة دفعة أخرى": "Add another payment",
  "إلغاء الفعالية": "Cancel event",
  "الدفع": "Payment",
  "الزبون نفسه": "Customer self-booked",
  "الله يحييك ضيفنا": "Welcome our guest",
  "تعديل الحجز —": "Edit booking —",
  "تعديل بيانات زبون مسجل محلياً": "Edit locally registered customer data",
  "تعذّر تعديل الحجز": "Couldn't edit the booking",
  "تعذّر حذف الزبون": "Couldn't delete the customer",
  "حجزك هنا": "your booking is here",
  "حجزه": "Booked by",
  "زبون سجّله موظف أو مدير عبر الحجز الداخلي": "Customer registered by staff or admin via internal booking",
  "سعر الجلسة": "Session price",
  "طباعة الفواتير": "Print invoices",
  "عدّل بيانات الحجز الداخلي القائم": "Edit the existing internal booking data",
  "فاضي = ما دفع شي · المبلغ كامل = تم الدفع تلقائياً": "Empty = paid nothing · Full amount = marked Paid in full automatically",
  "كراسي + جلسات": "Chairs + Sessions",
  "للتواصل والاقتراحات": "For contact & suggestions",
  "متأكد من حذف الزبون": "Are you sure you want to delete the customer",
  "✏️ تعديل الحجز الداخلي": "✏️ Edit internal booking",
  "أدوات الإدارة": "Management tools",
  "إضافة مقعد": "Add seat",
  "حجز ملغي": "Cancelled booking",
  "حجوزات ملغاة (كل الفعاليات)": "Cancelled bookings (all events)",
  "حجز داخلي (إغلاق المقعد)": "Internal booking (close seat)",
  "ملاحظة": "Note",
  "(اختياري)": "(optional)",
  "أرقام فقط · لو تركته فاضي يتحفظ كـ (—)": "Numbers only · if left empty, saved as (—)",
  "💳 الدفع": "💳 Payment",
  "سعر الجلسة:": "Session price:",
  "كاش": "Cash",
  "شبكة": "Card",
  "المبلغ": "Amount",
  "+ إضافة دفعة (كاش/شبكة)": "+ Add payment (cash/card)",
  "المدفوع": "Paid",
  "المتبقي": "Remaining",
  "لم يتم الدفع": "Not paid",
  "تم الدفع": "Paid in full",
  "دفع جزئي": "Partial payment",
  "اتركه فاضي = الزبون ما دفع شي (لم يتم الدفع). لو دفع المبلغ كامل يتحوّل تلقائياً إلى (تم الدفع).": "Leave empty = customer paid nothing (Not paid). If the full amount is paid, it switches automatically to (Paid in full).",
  "حذف الدفعة": "Remove payment",
  "مثال: يجلس مع مجموعة جدول 3 · طلب خاص...": "e.g. sits with table 3 group · special request...",
  "في حال إلغاء الفعالية، أو تأجيل المباراة من قبل الجهات الرسمية المنظمة، أو حدوث انقطاع عام في البث الفضائي لظروف خارجة عن إرادة المقهى (قوة قاهرة)، يلتزم المقهى بإعادة المبالغ المدفوعة إلى حسابات الزبائن أو تقييدها كرصيد بديل، دون أي مسؤولية إضافية لتعويض الزبون عن أي أضرار تابعة أو معنوية.": "In the event of the event's cancellation, or the postponement of the match by the official organizing bodies, or a general interruption of the broadcast due to circumstances beyond the cafe's control (force majeure), the cafe undertakes to refund the amounts paid to customers' accounts or credit them as alternative balance, without any additional liability to compensate the customer for any consequential or moral damages.",
  "يُعد إنشاء حساب جديد في هذه المنصة، أو استخدامها لحجز المقاعد والجلسات، إقراراً علنياً ومباشراً بالموافقة الكاملة وغير المشروطة على كافة البنود والسياسات الواردة أدناه. وفي حال عدم الموافقة على أي بند منها، يُرجى التوقف عن استخدام المنصة وعدم إتمام عملية التسجيل.": "Creating a new account on this platform, or using it to book seats and sessions, constitutes a public and direct acknowledgment of full and unconditional agreement to all the terms and policies listed below. If you do not agree to any of them, please stop using the platform and do not complete registration.",
  "2. الإلغاء المتأخر: في حال كان الوقت المتبقي على بدء الفعالية أو المباراة أقل من 6 ساعات، فإن القيمة المالية المدفوعة تصبح غير مستردة نهائياً، ولا يحق للزبون المطالبة بالتعويض أو تغيير موعد الحجز؛ نظراً لتفويت فرصة بيع المقعد لعملاء آخرين.": "2. Late cancellation: If the time remaining before the start of the event or match is less than 6 hours, the amount paid becomes strictly non-refundable, and the customer has no right to claim compensation or reschedule; due to missing the chance to sell the seat to other customers.",
  "تخضع هذه الشروط والأحكام وتُفسر وفقاً للأنظمة واللوائح السارية في المملكة العربية السعودية، وتختص الجهات القضائية والمحاكم السعودية بمدينة الرياض حصرياً بالنظر في أي نزاع أو خلاف قد ينشأ عن تفسير هذه الاتفاقية أو تطبيقها.": "These Terms & Conditions are governed by and interpreted according to the laws and regulations in force in the Kingdom of Saudi Arabia, and the Saudi judicial authorities and courts in the city of Riyadh have exclusive jurisdiction over any dispute arising from the interpretation or application of this agreement.",
  "2. تُعد هذه البيانات المرجع الأساسي والوحيد للتحقق الميداني عند بوابات الدفع والاستقبال بفرع المقهى، ولا يحق للمشترك المطالبة بحجزه أو تمكينه من المقعد في حال عدم تطابق البيانات المدخلة مع هويته الفعلية.": "2. This data is the primary and sole reference for on-site verification at the payment and reception gates of the cafe branch, and the subscriber has no right to claim the booking or seat access if the entered data does not match their actual identity.",
  "1. يقر الزبون ويعلم بأن هذه المنصة هي منتج برمجي إلكتروني، ومن الطبيعي والمألوف تقنياً تعرضها لبعض الأخطاء غير المقصودة، أو التحديثات الدورية، أو الانقطاع المؤقت في الخدمة، أو البطء في استجابة الخوادم.": "1. The customer acknowledges and knows that this platform is an electronic software product, and it is technically natural and common for it to be subject to some unintended errors, periodic updates, temporary service interruptions, or slowness in server response.",
  "3. لا تتحمل المنصة أو إدارة المقهى أي مسؤولية قانونية أو تعويضية عن أي خلل مؤقت في تحديث خريطة المقاعد، أو تعطل في معالجة الطلبات، طالما أن الإدارة تتخذ التدابير المعتادة لإصلاح المشاكل فور رصدها.": "3. The platform and cafe management bear no legal or compensatory liability for any temporary defect in updating the seat map, or failure in processing requests, as long as management takes the usual measures to fix issues once detected.",
  "2. لا تقوم المنصة بتخزين، أو الاحتفاظ، أو الاطلاع على أي بيانات تخص بطاقات الدفع (مدى، البطاقات الائتمانية) الخاصة بالزبائن، وتقتصر مسؤوليتها على استقبال تأكيد السداد الفوري من البوابة الوسيطة.": "2. The platform does not store, retain, or view any data related to customers' payment cards (Mada, credit cards), and its responsibility is limited to receiving instant payment confirmation from the intermediary gateway.",
  "3. فور اختيار المقعد أو الجلسة، يمنح النظام مهلة زمنية مدتها (10 دقائق فقط) لإتمام عملية السداد الإلكتروني بنجاح، وفي حال انقضاء المهلة دون دفع، يُلغى الحجز تلقائياً ويُعاد طرح المقعد للعموم.": "3. Once a seat or session is selected, the system grants a time window of (10 minutes only) to complete the electronic payment successfully, and if the window expires without payment, the booking is automatically cancelled and the seat is re-offered to the public.",
  "1. تطبيقاً لمبدأ تكافؤ الفرص ومنعاً للاحتكار، يُحدد السقف الأعلى للحجز لكل زبون في الفعالية أو المباراة الواحدة بـ (4 كراسي فردية) كحد أقصى، ويُسمح بأن يرافقها حجز (جلستين عاديتين) فقط.": "1. Applying the principle of equal opportunity and to prevent monopoly, the maximum booking limit per customer per event or match is set at (4 individual chairs) maximum, accompanied by booking (two regular sessions) only.",
  "1. الإلغاء المبكر: يحق للزبون إلغاء الحجز واسترداد القيمة المالية كاملة عبر المنصة، شريطة أن يتم تقديم طلب الإلغاء قبل موعد بدء الفعالية أو الجلسة بـ (6 ساعات) على الأقل.": "1. Early cancellation: The customer may cancel the booking and get a full refund via the platform, provided the cancellation request is submitted at least (6 hours) before the event or session start.",
  "2. يُحظر تجاوز هذه الحدود التشغيلية عبر الحساب الفردي، ولإدارة المقهى الحق المطلق في إلغاء أي حجوزات فائضة أو مشتبه في غرضها الاستثماري أو الاحتكاري دون أدنى مسؤولية.": "2. Exceeding these operational limits via the individual account is prohibited, and cafe management has the absolute right to cancel any excess bookings or those suspected of investment or monopolistic purpose without any liability.",
  "1. يتحمل المستخدم (الزبون) المسؤولية القانونية الكاملة عن صحة ودقة البيانات المدخلة أثناء إنشاء الحساب، وتحديداً: الاسم الثلاثي، ورقم الجوال، والبريد الإلكتروني.": "1. The user (customer) bears full legal responsibility for the accuracy of the data entered during account creation, specifically: the full (triple) name, mobile number, and email.",
  "3. يخضع الإجراء البنكي لإعادة المبالغ المستردة (Refunds) للمدد الزمنية المعتمدة لدى بوابات الدفع والبنوك المحلية، والتي تتراوح عادةً بين (2 إلى 14 يوم عمل).": "3. The banking procedure for refunds is subject to the approved timeframes of payment gateways and local banks, which usually range between (2 to 14 business days).",
  "3. يلتزم المستخدم بالمحافظة التامة على سرية بيانات دخوله (كلمة المرور)، ويتحمل وحده المسؤولية عن أي نشاط أو حجز يتم إجراؤه عبر حسابه.": "3. The user commits to fully maintaining the confidentiality of their login data (password), and bears sole responsibility for any activity or booking made through their account.",
  "1. تُعالج كافة العمليات المالية من خلال بوابات دفع إلكترونية وسيطة ومستقلة، ومعتمدة رسمياً من البنك المركزي السعودي (ساما).": "1. All financial operations are processed through independent intermediary electronic payment gateways, officially approved by the Saudi Central Bank (SAMA).",
  "2. تُقدَّم خدمات المنصة بوضعها الراهن وحالتها المتاحة (As Is) دون أي ضمانات مطلقة بالخلو التام من العيوب التقنية العارضة.": "2. Platform services are provided as-is and as available, without any absolute warranties of complete freedom from incidental technical defects.",
  "الأسعار الافتراضية للمقاعد عند إنشاء أي فعالية جديدة. تُطبّق على الفعاليات الجديدة فقط ولا تغيّر الفعاليات الموجودة.": "The default seat prices when creating any new event. Applied to new events only and do not change existing events.",
  "لو تركته فارغاً تُعتبر الفعالية مباشرة لمدة ساعة. عند وصول وقت النهاية تصبح الفعالية سابقة.": "If left empty, the event is considered live for one hour. When the end time arrives, the event becomes past.",
  "يجب الاطلاع والموافقة على الشروط والأحكام وسياسة الاستخدام قبل إنشاء الحساب.": "You must read and agree to the Terms & Conditions and Usage Policy before creating the account.",
  "❌ لا يمكن الإلغاء — تبقّى أقل من 6 ساعات على الموعد (لا يُسترد المبلغ)": "❌ Cannot cancel — less than 6 hours left before the time (non-refundable)",
  "📨 تم إرسال رمز التحقق (يظهر مؤقتاً بسجل الخادم لحين ربط خدمة الإيميل)": "📨 Verification code sent (shown temporarily in the server log until email service is connected)",
  "كلمة المرور يجب أن تكون 8 خانات على الأقل وتحتوي حرفاً كبيراً ورمزاً.": "Password must be at least 8 characters and contain a capital letter and a symbol.",
  "إرجاع الأسعار الافتراضية إلى: الكراسي 20 · الجلسات 70 · الغرف 150؟": "Restore default prices to: Chairs 20 · Sessions 70 · Rooms 150?",
  "📌 وقت وتاريخ الحجز الأصلي قبل الإلغاء · مرتّبة من الأحدث للأقدم": "📌 Original booking date & time before cancellation · sorted newest to oldest",
  "يمكنك إلغاء الحجز واسترداد المبلغ كاملاً قبل موعد الفعالية بـ": "You can cancel the booking and get a full refund before the event time by",
  "أدخل بريدك الإلكتروني وجوالك المسجلين، وكلمة مرور جديدة": "Enter your registered email and mobile, and a new password",
  "البند السابع: القانون الواجب التطبيق والاختصاص القضائي": "Article Seven: Governing Law and Judicial Jurisdiction",
  "البند الثالث: سياسة الدفع، الإلغاء، والاسترداد المالي": "Article Three: Payment, Cancellation, and Refund Policy",
  "على الأقل. بعد ذلك لا يمكن الإلغاء ولا يُسترد المبلغ.": "at least. After that, cancellation is not allowed and no refund.",
  "بيانات لحظية لهذه الفعالية فقط · لا تحتاج تسجيل حساب": "Live data for this event only · no account required",
  "🔒 الموظف يشوف بيانات الزبون ويقدر يعيد فتح المقاعد": "🔒 Staff can view customer data and reopen seats",
  "تحقق من سجلّ الخادم مؤقتاً لحين ربط خدمة الإيميل": "Check the server log temporarily until email service is connected",
  "اضغط الزر لإرسال رمز التحقق إلى بريدك الإلكتروني": "Press the button to send a verification code to your email",
  "البند الخامس: بوابات الدفع وأمن البيانات المالية": "Article Five: Payment Gateways and Financial Data Security",
  "بياناتك مسجّلة في حسابك — لا حاجة لإعادة الكتابة": "Your data is saved in your account — no need to retype",
  "✅ تم تعيين كلمة مرور جديدة، سجّل دخولك بها الحين": "✅ New password set, log in with it now",
  "سيتم توليد الخريطة (27 مقعد) تلقائياً عند الحفظ": "The map (27 seats) will be generated automatically on save",
  "متأكد من إعادة فتح المقعد؟ سيُلغى الحجز الحالي.": "Are you sure you want to reopen the seat? The current booking will be cancelled.",
  "البند الأول: أهلية الحساب وصحة البيانات الشخصية": "Article One: Account Eligibility and Accuracy of Personal Data",
  "وقت نهاية الفعالية يجب أن يكون بعد وقت البداية.": "The event end time must be after the start time.",
  "تعذّر الاتصال بالخادم. تأكد أن الباك إند يعمل.": "Could not connect to the server. Make sure the backend is running.",
  "❌ يوجد حجز أقل من 6 ساعات — لا يمكن إلغاء الكل": "❌ A booking is under 6 hours — cannot cancel all",
  "البند الرابع: إخلاء المسؤولية الفنية والتقنية": "Article Four: Technical Disclaimer",
  "كلمة المرور ضعيفة — 8 خانات + حرف كبير + رمز": "Weak password — 8 characters + capital + symbol",
  "متأكد من إلغاء الحجز؟ سيُسترد المبلغ كاملاً.": "Are you sure you want to cancel the booking? The amount will be fully refunded.",
  "اضغط الزر لإرسال رمز التحقق إلى بريدك الحالي": "Press the button to send a verification code to your current email",
  "البند الثاني: سياسة الحجز والحدود التشغيلية": "Article Two: Booking Policy and Operational Limits",
  "سيتم تحويلك لإتمام الدفع بأمان لتأكيد الحجز": "You will be redirected to complete payment securely to confirm the booking",
  "البند السادس: القوة القاهرة والظروف الطارئة": "Article Six: Force Majeure and Emergencies",
  "تعذّر تحميل بيانات المستخدمين من الباك إند": "Failed to load users from the backend",
  "سيتمكن الموظف من الدخول بالبريد الإلكتروني": "Staff will be able to log in using the email",
  "🔒 فعالية سابقة — عرض فقط، لا يمكن التعديل": "🔒 Past event — view only, cannot edit",
  "انتهت هذه الفعالية — لا يمكن الدخول إليها": "This event has ended — cannot enter it",
  "✅ تم إلغاء الفعالية — محفوظة بسجل الملغية": "✅ Event cancelled — saved in the cancelled log",
  "🪑 الكراسي حتى 4 · 🛋️ الجلسات و VIP حتى 2": "🪑 Chairs up to 4 · 🛋️ Sessions & VIP up to 2",
  "✅ تم إلغاء الحجز — سيُسترد المبلغ كاملاً": "✅ Booking cancelled — amount will be fully refunded",
  "رقم الجوال يجب أن يكون 10 أرقام بالضبط.": "Mobile number must be exactly 10 digits.",
  "لا توجد فعاليات قادمة أو مباشرة حالياً.": "No upcoming or live events currently.",
  "هل أنت متأكد من حذف هذا الحساب نهائياً؟": "Are you sure you want to permanently delete this account?",
  "عذراً، يجب إدخال الاسم الثلاثي للتسجيل.": "Sorry, you must enter the full (triple) name to register.",
  "لا توجد فعاليات متاحة أو مباشرة حالياً": "No available or live events currently",
  "🔒 انتهت مهلة الإلغاء (أقل من 6 ساعات)": "🔒 Cancellation window ended (less than 6 hours)",
  "سيضاف المقعد لخريطة الفعالية الحالية": "The seat will be added to the current event map",
  "رقم جوال الموظف يجب أن يكون 10 أرقام": "Staff mobile number must be 10 digits",
  "الرجاء إدخال أسعار صحيحة (0 أو أكثر)": "Please enter valid prices (0 or more)",
  "لو عبّيته: 8 خانات + حرف كبير + رمز": "If filled: 8 characters + capital + symbol",
  "تعذّر تحميل الفعاليات من الباك إند": "Failed to load events from the backend",
  "الشروط والأحكام وسياسة الاستخدام ☕": "Terms & Conditions and Usage Policy ☕",
  "✅ تم تغيير البريد الإلكتروني بنجاح": "✅ Email changed successfully",
  "8 خانات على الأقل + حرف كبير + رمز": "8 characters minimum + capital + symbol",
  "تعذّر تحميل سجل الفعاليات الملغية": "Failed to load the cancelled events log",
  "👑 الدور الثاني · غرف VIP والجلسات": "👑 Floor 2 · VIP rooms and sessions",
  "مثال: الكلاسيكو · الهلال × النصر": "e.g. El Clásico · Al-Hilal × Al-Nassr",
  "سجّل دخولك أو أنشئ حساباً جديداً": "Log in or create a new account",
  "الشروط والأحكام وسياسة الاستخدام": "Terms & Conditions and Usage Policy",
  "رقم الجوال يجب أن يكون 10 أرقام": "Mobile number must be 10 digits",
  "🚬 مسموح التدخين في الدور الثاني": "🚬 Smoking allowed on floor 2",
  "🚭 ممنوع التدخين في الدور الأول": "🚭 No smoking on floor 1",
  "بياناتك (للتعديل راجع المدير)": "Your data (contact the admin to edit)",
  "✅ تم تأكيد الحجز والدفع بنجاح": "✅ Booking and payment confirmed successfully",
  "تعذّر تغيير البريد الإلكتروني": "Failed to change email",
  "✅ تم إرجاع الأسعار الافتراضية": "✅ Default prices restored",
  "اتركه فاضي أو اكتب اسم الزبون": "Leave empty or type the customer name",
  "✅ تم تغيير كلمة المرور بنجاح": "✅ Password changed successfully",
  "صلاحية إنشاء وتعديل المواعيد": "Permission to create and edit events",
  "لا توجد فعاليات سابقة لحذفها": "No past events to delete",
  "✅ تم حفظ بيانات المدير بنجاح": "✅ Admin data saved successfully",
  "✅ تم إعادة تعيين كلمة المرور": "✅ Password reset done",
  "تعذّر نقل الفعاليات السابقة": "Failed to move past events",
  "🗑️ حذف كل الفعاليات السابقة": "🗑️ Delete all past events",
  "البريد الإلكتروني غير صحيح.": "Email is invalid.",
  "الفعاليات القادمة والمباشرة": "Upcoming and live events",
  "✅ تم حفظ الأسعار الافتراضية": "✅ Default prices saved",
  "احجز جلستك وعِش تجربة رايقة": "Book your session and enjoy a relaxing experience",
  "↺ إرجاع الأسعار الافتراضية": "↺ Restore default prices",
  "✅ تم تحديث بيانات المستخدم": "✅ User data updated",
  "البريد الإلكتروني غير صحيح": "Email is invalid",
  "⚙️ تعديل المعلومات والسعر": "⚙️ Edit info and price",
  "كلمة مرور جديدة (اختياري)": "New password (optional)",
  "🗑️ تم إفراغ السجل نهائياً": "🗑️ Log permanently emptied",
  "اتركه فارغاً لعدم التغيير": "Leave empty to keep unchanged",
  "قيد الدفع (كل الفعاليات)": "Pending payment (all events)",
  "اتركه فاضي أو اكتب الرقم": "Leave empty or type the number",
  "(اتركه فاضي = حجز داخلي)": "(empty = internal booking)",
  "🗑️ سجل الفعاليات الملغية": "🗑️ Cancelled events log",
  "البريد الإلكتروني الجديد": "New email",
  "سعر الغرفة VIP الافتراضي": "Default VIP room price",
  "إغلاق المقعد (حجز داخلي)": "Close seat (internal booking)",
  "🎉 استمتع بأجواء لا تُنسى": "🎉 Enjoy unforgettable vibes",
  "تعذّر إلغاء كل الحجوزات": "Failed to cancel all bookings",
  "تعذّر تغيير كلمة المرور": "Failed to change password",
  "تغيير البريد الإلكتروني": "Change email",
  "إجمالي الزبائن المسجلين": "Total registered customers",
  "🗑️ سجل الحجوزات الملغاة": "🗑️ Cancelled bookings log",
  "إعادة تعيين كلمة المرور": "Reset password",
  "✅ تم إضافة الموظف بنجاح": "✅ Staff added successfully",
  "أهلاً بك في قَدُوع كِيف": "Welcome to Qadooa Cafe",
  "🗺️ خريطة الحجوزات الحية": "🗺️ Live bookings map",
  "تعذّر إعادة فتح المقعد": "Failed to reopen the seat",
  "لا توجد فعاليات حالياً": "No events currently",
  "تعذّر إرسال رمز التحقق": "Failed to send verification code",
  "تعذّر استرجاع الفعالية": "Failed to restore the event",
  "🕐 تعديل الوقت والتاريخ": "🕐 Edit time and date",
  "لا توجد فعاليات ملغية.": "No cancelled events.",
  "لا توجد فعاليات سابقة.": "No past events.",
  "تعذّر الاتصال بالخادم.": "Could not connect to the server.",
  "الافتراضي الأساسي: 150": "Base default: 150",
  "لا توجد حجوزات للطباعة": "No bookings to print",
  "🖨️ طباعة هذه الفاتورة": "🖨️ Print this invoice",
  "تعديل بيانات المستخدم": "Edit user data",
  "عبدالله محمد القحطاني": "Abdullah Mohammed Alqahtani",
  "✅ تم استرجاع الفعالية": "✅ Event restored",
  "✅ تم حفظ تعديل المقعد": "✅ Seat edit saved",
  "تعذّر التعديل الجماعي": "Bulk edit failed",
  "الافتراضي الأساسي: 70": "Base default: 70",
  "وقت النهاية (اختياري)": "End time (optional)",
  "لا توجد فعاليات سابقة": "No past events",
  "✅ تم إعادة فتح المقعد": "✅ Seat reopened",
  "الافتراضي الأساسي: 20": "Base default: 20",
  "✅ تم إلغاء كل حجوزاتك": "✅ All your bookings cancelled",
  "لا توجد حجوزات مسجلة.": "No bookings recorded.",
  "سعر الجلسة الافتراضي": "Default session price",
  "منظومة إدارة الجلسات": "Session management system",
  "تعذّر تحديث البيانات": "Failed to update data",
  "سعر الكرسي الافتراضي": "Default chair price",
  "تعذّر إلغاء الفعالية": "Failed to cancel the event",
  "هذا المقعد غير متاح": "This seat is unavailable",
  "🕓 الفعاليات السابقة": "🕓 Past events",
  "✅ تم تعديل الفعالية": "✅ Event edited",
  "إفراغ السجل نهائياً": "Empty the log permanently",
  "✅ تم إنشاء الفعالية": "✅ Event created",
  "تعذّر تنفيذ العملية": "Failed to perform the operation",
  "تأكيد الحجز الداخلي": "Confirm internal booking",
  "كراسي + جلسات أرضية": "Chairs + floor sessions",
  "🏟️ تفاصيل الفعاليات": "🏟️ Events details",
  "تعذّر إرجاع الأسعار": "Failed to restore prices",
  "تعذّر الحذف النهائي": "Failed permanent delete",
  "تعذّر الحجز الداخلي": "Internal booking failed",
  "زبائن لديهم حجز نشط": "Customers with an active booking",
  "💰 إعدادات الفعاليات": "💰 Event settings",
  "كلمة المرور الجديدة": "New password",
  "لا يوجد حجز لطباعته": "No booking to print",
  "تعذّر إعادة التعيين": "Reset failed",
  "استرجاع كلمة المرور": "Recover password",
  "🗑️ تم الحذف النهائي": "🗑️ Log permanently emptied",
  "منصة «قَدُوع كِيف»": "«Qadooa Cafe» platform",
  "أُعيد الفتح بواسطة": "Reopened by",
  "✅ تم الحجز الداخلي": "✅ Internal booking done",
  "تعذّر إضافة الموظف": "Failed to add staff",
  "📅 إيرادات يوم محدد": "📅 Revenue for a specific day",
  "تعذّر حفظ الفعالية": "Failed to save the event",
  "تعذّر حفظ البيانات": "Failed to save data",
  "💰 تفاصيل الإيرادات": "💰 Revenue details",
  "جلسات الدور الثاني": "Floor 2 sessions",
  "إضافة مقعد أو جلسة": "Add seat or session",
  "رجوع لتسجيل الدخول": "Back to login",
  "تعذّر إضافة المقعد": "Failed to add seat",
  "تعذّر إفراغ السجل": "Failed to empty the log",
  "الفعاليات السابقة": "Past events",
  "إعادة فتح المقعد؟": "Reopen the seat?",
  "الإدارة التفصيلية": "Detailed administration",
  "البريد الإلكتروني": "Email",
  "تغيير كلمة المرور": "Change password",
  "🗑️ حذف هذا المقعد": "🗑️ Delete this seat",
  "تعذّر إلغاء الحجز": "Failed to cancel the booking",
  "🖨️ طباعة الفواتير": "🖨️ Print invoices",
  "🖨️ طباعة الفاتورة": "🖨️ Print invoice",
  "نسيت كلمة المرور؟": "Forgot password?",
  "🗑️ إلغاء الفعالية": "🗑️ Cancel event",
  "تعيين كلمة المرور": "Set password",
  "+ إنشاء موعد جديد": "+ Create new event",
  "تعذّر تأكيد الحجز": "Failed to confirm the booking",
  "تعذّر حفظ الأسعار": "Failed to save prices",
  "✅ تم إضافة المقعد": "✅ Seat added",
  "🛠️ أُنشئت بواسطة": "🛠️ Created by",
  "(اتركه فاضي = —)": "(empty = —)",
  "الدفع الإلكتروني": "Online payment",
  "تعذّر حذف الحساب": "Failed to delete the account",
  "👥 تفاصيل الزبائن": "👥 Customers details",
  "لا توجد فعاليات.": "No events.",
  "سجّل دخولك أولاً": "Log in first",
  "إجمالي الفعاليات": "Total events",
  "الإيرادات الكلية": "Total revenue",
  "⚙️ تعديل الجلسات": "⚙️ Edit sessions",
  "إعادة فتح المقعد": "Reopen seat",
  "تطبيق على الجميع": "Apply to all",
  "إرسال رمز التحقق": "Send verification code",
  "زبائن لديهم حجز": "Customers with a booking",
  "إلغاء هذا الحجز": "Cancel this booking",
  "✅ تم حذف الحساب": "✅ Account deleted",
  "غرف VIP + جلسات": "VIP rooms + sessions",
  "إضافة موظف جديد": "Add new staff",
  "الجلسات الأرضية": "Floor sessions",
  "✅ تم حذف المقعد": "✅ Seat deleted",
  "إضافة موعد جديد": "Add new event",
  "اضغط للتفاصيل ↓": "Tap for details ↓",
  "10 أرقام بالضبط": "Exactly 10 digits",
  "🔎 ابحث بالعنوان": "🔎 Search by title",
  "سياسة الإلغاء:": "Cancellation policy:",
  "إجمالي الزبائن": "Total customers",
  "👑 لوحة الإدارة": "👑 Admin panel",
  "التاريخ والوقت": "Date and time",
  "عنوان الفعالية": "Event title",
  "⚙️ تعديل جماعي": "⚙️ Bulk edit",
  "الإيراد المؤكد": "Confirmed revenue",
  "زبائن بدون حجز": "Customers without a booking",
  "📺 شاشة الكراسي": "📺 Chairs screen",
  "أُلغيت بواسطة": "Cancelled by",
  "تأكيد الحجز ←": "Confirm booking →",
  "تأكيد التغيير": "Confirm change",
  "حفظ التعديلات": "Save changes",
  "بداية - نهاية": "Start - End",
  "إيراد الكراسي": "Chairs revenue",
  "فعاليات ملغية": "Cancelled events",
  "☕ قَدُوع كِيف": "☕ Qadooa Cafe",
  "الاسم الثلاثي": "Full (triple) name",
  "الإيراد الكلي": "Total revenue",
  "إيراد الجلسات": "Sessions revenue",
  "اضغط للسجل ↓": "Tap for log ↓",
  "الدفع الآن 💳": "Pay now 💳",
  "اختر التاريخ": "Choose the date",
  "+ إضافة موظف": "+ Add staff",
  "سجل الحجوزات": "Bookings log",
  "⚙️ تعديل VIP": "⚙️ Edit VIP",
  "الاسم الكامل": "Full name",
  "تسجيل الدخول": "Login",
  "فواتير الحجز": "Booking invoices",
  "إضافة للمخطط": "Add to map",
  "اسم الفعالية": "Event name",
  "+ إضافة مقعد": "+ Add seat",
  "الدور الثاني": "Floor 2",
  "السعر (ريال)": "Price (SAR)",
  "🧑‍🍳 الموظفين": "🧑‍🍳 Staff",
  "تعديل المقعد": "Edit seat",
  "تعديل الموعد": "Edit event",
  "الملف الشخصي": "Profile",
  "تعديل جماعي": "Bulk edit",
  "حفظ الأسعار": "Save prices",
  "إيراد اليوم": "Today revenue",
  "كلمة المرور": "Password",
  "إتمام الحجز": "Complete booking",
  "مع مشروب...": "With a drink...",
  "وقت البداية": "Start time",
  "الدور الأول": "Floor 1",
  "قرأت وأوافق": "Read & agree",
  "قَدُوع كِيف": "Qadooa Cafe",
  "✕ إعادة فتح": "✕ Reopen",
  "فاتورة حجز": "Booking invoice",
  "حفظ الموظف": "Save staff",
  "رقم الجوال": "Mobile number",
  "رمز التحقق": "Verification code",
  "اسم الزبون": "Customer name",
  "إلغاء الكل": "Cancel all",
  "الحجز باسم": "Booking under name",
  "مباشر الآن": "Live now",
  "↩️ استرجاع": "↩️ Restore",
  "إنشاء حساب": "Create account",
  "اسم الموظف": "Staff name",
  "👑 الإدارة": "👑 Admin",
  "إيراد VIP": "VIP revenue",
  "حذف نهائي": "Delete permanently",
  "👥 الزبائن": "👥 Customers",
  "عرض الملف": "View profile",
  "📅 التاريخ": "📅 Date",
  "الإجمالي:": "Total:",
  "قيد الدفع": "Pending payment",
  "حساب جديد": "New account",
  "🖨️ طباعة": "🖨️ Print",
  "🔐 الأمان": "🔐 Security",
  "الموظفين": "Staff",
  "غرفة VIP": "VIP room",
  "VIP فاخر": "VIP luxury",
  "الفعالية": "Event",
  "الإجمالي": "Total",
  "غرف VIP": "VIP rooms",
  "بياناتك": "Your data",
  "⏰ الوقت": "⏰ Time",
  "👤 حسابي": "👤 My account",
  "كرسي 15": "Chair 15",
  "الكراسي": "Chairs",
  "التعديل": "Edit",
  "6 ساعات": "6 hours",
  "إجراءات": "Actions",
  "التاريخ": "Date",
  "📊 ملخّص": "📊 Summary",
  "منتهية": "Ended",
  "المقعد": "Seat",
  "الحالة": "Status",
  "الجوال": "Mobile",
  "← رجوع": "← Back",
  "الزبون": "Customer",
  "اخترته": "my choice",
  "الجلسة": "Session",
  "تمهيد:": "Preamble:",
  "النوع": "Type",
  "إجراء": "Action",
  "إلغاء": "Cancel",
  "مباشر": "Live",
  "الوصف": "Description",
  "السعر": "Price",
  "الدور": "Floor",
  "الوقت": "Time",
  "تعديل": "Edit",
  "الدرج": "Stairs",
  "الاسم": "Name",
  "محجوز": "Booked",
  "فارغ": "Empty",
  "موظف": "Staff",
  "خروج": "Exit",
  "متاح": "Available",
  "كرسي": "Chair",
  "دخول": "Login",
  "جلسة": "Session",
  "زبون": "Customer",
  "رجوع": "Back",
  "حفظ": "Save",
  "مسح": "Clear",
  "حذف": "Delete",
  "ص": "AM",
  "م": "PM",
  "تاريخ الطباعة:": "Printed on:",
  "أقرّ بأنني اطّلعت وأوافق على": "I have read and agree to",
  "الدعم الفني والشكاوى": "Technical Support & Complaints",
  "موقع المكان": "Location",
  "الشروط والأحكام": "Terms & Conditions",
  "نسخة تجريبية": "Beta version",
  "بحد أقصى": "Maximum",
  "كراسي لكل فعالية": "chairs per event",
  "جلسات/غرف لكل فعالية": "sessions/rooms per event",
  "إلغاء كل الحجوزات": "Cancel all bookings",
  "سيُسترد المبلغ كاملاً.": "The amount will be fully refunded.",
  "فواتير": "Invoices",
  "متأكد من إلغاء فعالية": "Are you sure you want to cancel the event",
  "يمكنك استرجاعها لاحقاً من سجل الفعاليات الملغية.": "You can restore it later from the cancelled events log.",
  "سيتم نقل": "Will move",
  "فعالية سابقة لسجل الملغية (يمكن استرجاعها). متأكد؟": "past events to the cancelled log (can be restored). Sure?",
  "تم نقل": "Moved",
  "فعالية لسجل الملغية": "events to the cancelled log",
  "استرجاع فعالية": "Restore event",
  "حذف نهائي لفعالية": "Permanently delete event",
  "لا يمكن التراجع بعدها.": "This cannot be undone.",
  "حذف نهائي لكل السجل": "Permanently delete the entire log",
  "فعالية": "events",
  "لا يمكن التراجع.": "This cannot be undone.",
  "متأكد من حذف": "Are you sure you want to delete",
  "تم تحديث كل مقاعد": "Updated all seats of",
  "دفعة وحدة": "in one batch",
  "🏟️ الفعاليات المتاحة": "🏟️ Available events",
  "🔒 فعالية سابقة — للاطّلاع فقط. لا يمكن التعديل، عدا تصحيح الوقت والتاريخ لإعادة تفعيلها.": "🔒 Past event — view only. Cannot edit, except correcting the time and date to reactivate it.",
  "نسبة الحجز": "Occupancy",
  "الفارغ:": "Empty:",
  "البريد الحالي:": "Current email:",
  "حجز داخلي —": "Internal booking —",
  "سيُطبّق التعديل على كل مقاعد": "The change will apply to all seats of",
  "دفعة وحدة (الاسم والحالة يبقون كما هم)": "in one batch (name and status remain unchanged)",
  "غرفة": "rooms",
  "مع كوب صغير من اختيارك": "With a small cup of your choice",
  "مع دلة وبريق شاهي": "With a dallah and a pot of tea",
  "دلة وبريق شاهي، حلا، مكسرات، ماء": "Dallah & tea pot, dessert, nuts, water",

  /* ===== رمز التحقق بالبريد — حساب جديد / نسيت كلمة المرور ===== */
  "أرسلنا رمز تحقق إلى": "We sent a verification code to",
  "رجوع لتعديل البيانات": "Back to edit details",
  "تأكيد إنشاء الحساب": "Confirm account creation",
  "أدخل بريدك الإلكتروني المسجّل وسنرسل لك رمز تحقق": "Enter your registered email and we'll send you a verification code",
  "تحقق من بريدك الإلكتروني، بما فيه الرسائل المزعجة": "Check your email, including spam/junk folder",

  /* ===== سجل الحجوزات الملغية / السابقة ===== */
  "منتهي": "Ended",
  "ملغي": "Cancelled",
  "الحجوزات الملغية": "Cancelled bookings",
  "لا توجد حجوزات ملغية.": "No cancelled bookings.",
  "فواتير الحجوزات الملغية": "Cancelled bookings invoices",
  "فاتورة حجز ملغي": "Cancelled booking invoice",
  "وقت الإلغاء": "Cancelled at",

  /* ===== أقسام الحجوزات (أكورديون) + صفحة عرض الكل ===== */
  "الحجوزات الحالية": "Current bookings",
  "الحجوزات السابقة": "Past bookings",
  "لا توجد حجوزات حالية.": "No current bookings.",
  "لا توجد حجوزات سابقة.": "No past bookings.",
  "لا توجد حجوزات.": "No bookings.",
  "فواتير الحجوزات الحالية": "Current bookings invoices",
  "فواتير الحجوزات السابقة": "Past bookings invoices",
  "عرض الكل": "View all",
  "السابق": "Previous",
  "التالي": "Next",
  "◂ رجوع للملف الشخصي": "◂ Back to profile",

  /* ===== بحث خريطة الحجوزات الحية + بحث الزبائن بالإدارة ===== */
  "🔎 ابحث برقم الجلسة، النوع، الاسم، أو الجوال": "🔎 Search by seat number, type, name, or phone",
  "مثال: جلسة 3، كرسي، عبدالله، 05...": "e.g. Session 3, Chair, Abdullah, 05...",
  "لا نتائج مطابقة.": "No matching results.",
  "🔎 ابحث بالاسم، البريد الإلكتروني، أو الجوال": "🔎 Search by name, email, or phone",
  "اسم الزبون، البريد، أو رقم الجوال": "Customer name, email, or phone number",

  "إرجاع الأسعار والأوصاف الافتراضية إلى القيم الأصلية؟": "Restore default prices and descriptions to their original values?",
  "إلى": "to",
  "اسم الزبون أو رقم الجوال": "Customer name or phone number",
  "الأسعار والأوصاف الافتراضية للمقاعد عند إنشاء أي فعالية جديدة. تُطبّق على الفعاليات الجديدة فقط ولا تغيّر الفعاليات الموجودة.": "Default seat prices and descriptions when creating a new event. Applied to new events only and do not change existing events.",
  "تاريخ التسجيل": "Registration date",
  "تعذّر تحميل الزبائن المسجلين محلياً": "Failed to load locally registered customers",
  "تنبيه: هذا المقعد محجوز حالياً وبيانات الحجز بتُفقد نهائياً.": "Warning: this seat is currently booked and its booking data will be permanently lost.",
  "حفظ الأسعار والأوصاف": "Save prices & descriptions",
  "زبائن سجّل بياناتهم موظف أو مدير يدوياً عبر الحجز الداخلي (مو أصحاب حساب فعلي بالموقع).": "Customers whose data was manually registered by a staff member or admin via internal booking (not actual account holders on the site).",
  "سجّل دخولك لإتمام الحجز": "Log in to complete the booking",
  "سجّله": "Registered by",
  "كل الزبائن": "All customers",
  "كل الزبائن المسجلين محلياً": "All locally registered customers",
  "كل الفعاليات السابقة": "All past events",
  "من": "from",
  "وصف الجلسة الافتراضي": "Default session description",
  "وصف الغرفة الخاصة (VIP) الافتراضي": "Default VIP room description",
  "وصف الكرسي الافتراضي": "Default chair description",
  "وقت نهاية الفعالية يجب أن يختلف عن وقت البداية.": "The event end time must be different from the start time.",
  "↺ إرجاع الافتراضي الأصلي": "↺ Restore original defaults",
  "◂ رجوع": "◂ Back",
  "✅ تم إرجاع الأسعار والأوصاف الافتراضية": "✅ Default prices and descriptions restored",
  "✅ تم حفظ الأسعار والأوصاف الافتراضية": "✅ Default prices and descriptions saved",
  "🔎 ابحث بالاسم أو الجوال": "🔎 Search by name or phone",
  "🧾 زبائن مسجلين محلياً": "🧾 Locally registered customers",

  /* ترجمات إضافية للنصوص الظاهرة في بطاقات الحجوزات */
  "مدفوع": "Paid",
  "بواسطة": "By",
  "حجز داخلي بواسطة": "Internal booking by"
};

export default translations;